import { ICON_COLORS } from './icons.constants'
import { IconProps } from './icons.types'

export const CampaignsIcon = ({
  width = 18,
  height = 18,
  primaryColor = ICON_COLORS.PRIMARY.DEFAULT,
  secondaryColor = ICON_COLORS.SECONDARY.DEFAULT,
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_6097_27228)'>
        <path
          d='M6.75 4.5V5.625V6.75V10.125V11.25V12.375H7.05586C9.44297 12.375 11.7316 13.3242 13.4191 15.0117L14.952 16.5445C15.2754 16.868 15.757 16.9629 16.1789 16.7871C16.6008 16.6113 16.875 16.2035 16.875 15.7465V10.5574V6.31406V1.125C16.875 0.671484 16.6008 0.260156 16.1789 0.084375C16.0418 0.028125 15.8941 0 15.75 0C15.4582 0 15.1699 0.116016 14.9555 0.330469L13.4191 1.86328C11.7316 3.55078 9.44297 4.5 7.05586 4.5C6.95391 4.5 6.85195 4.5 6.75 4.5Z'
          fill={secondaryColor}
        />
        <path
          d='M0 6.75C0 5.50898 1.00898 4.5 2.25 4.5H6.75V11.25V12.375V16.875C6.75 17.4973 6.24727 18 5.625 18H3.375C2.75273 18 2.25 17.4973 2.25 16.875V12.375C1.00898 12.375 0 11.366 0 10.125V6.75ZM18 8.4375C18 9.41836 17.5289 10.2516 16.875 10.5609V6.31758C17.5289 6.62695 18 7.46016 18 8.44102V8.4375Z'
          fill={primaryColor}
        />
      </g>
      <defs>
        <clipPath id='clip0_6097_27228'>
          <rect
            width='18'
            height='18'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
